import Client from './Clients/ScrapingToolsClient'

const downloadResultsResource = '/outputs/location/results/'
const downloadJobGroupResultsResource = '/outputs/location/results/job_group/'

export default{
    downloadResults(searchJobId){
        return Client.get(downloadResultsResource+searchJobId+'/',{responseType:'blob'});
    },
    downloadJobGroupResults(jobGroupLogId){
        return Client.get(downloadJobGroupResultsResource+jobGroupLogId+'/',{responseType:'blob'});
    }
}